export const ReportTypeConstants = {
  BASIC: "basic",
  EXTENDED: "extended",
};
